<template>
    <v-container fluid class="pa-4">
        <v-row>
            <v-col cols="12">
                <v-card elevation="2">
                    <v-card-title class="title">
                        <v-icon left>mdi-forum-outline</v-icon>
                        Welcome Statement ({{ welcomeInteractions.length }})
                    </v-card-title>
                    <v-card-text v-if="welcomeInteractions.length">
                        <v-list two-line>
                            <v-list-item-group>
                                <v-card
                                    v-for="(interaction, index) in welcomeInteractions"
                                    :key="interaction.interaction_id"
                                    class="mb-3"
                                    outlined
                                >
                                    <v-card-subtitle class="d-flex align-center pb-2 grey lighten-4">
                                        <div class="font-weight-bold grey--text text--darken-3">
                                            <v-icon small class="mr-1">mdi-message-text-outline</v-icon>
                                            INTERACTION #{{ index + 1 }}
                                        </div>

                                        <v-spacer></v-spacer>

                                        <v-chip
                                            small
                                            label
                                            outlined
                                            color="primary"
                                            class="font-weight-bold"
                                        >
                                            {{ interaction.type || 'N/A' }}
                                        </v-chip>
                                        </v-card-subtitle>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <div 
                                                v-for="(message, mIdx) in interaction.msg" 
                                                :key="mIdx" 
                                                class="d-flex align-center mb-3"
                                                >
                                                <v-text-field
                                                    :label="`Message ${mIdx + 1}`"
                                                    :value="message.text || ''"
                                                    outlined
                                                    readonly
                                                    hide-details
                                                    dense
                                                    class="mr-2"
                                                ></v-text-field>
                                                
                                                <v-btn 
                                                    small 
                                                    icon 
                                                    color="primary" 
                                                    @click.stop.prevent="openEditModal('welcome', interaction, mIdx)"
                                                >
                                                    <v-icon small>mdi-pencil</v-icon>
                                                </v-btn>
                                                <v-btn small icon color="red" @click.stop.prevent="opendelete(interaction, 'welcome')">
                                                <v-icon small>mdi-delete</v-icon>
                                            </v-btn>
                                            </div>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-card>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-alert type="warning" outlined dense>No welcome interactions found.</v-alert>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12">
                <v-card elevation="2">
                    <v-card-title class="title">
                        <v-icon left>mdi-forum-outline</v-icon>
                        Closing Statement ({{ closingInteractions.length }})
                    </v-card-title>
                    <v-card-text v-if="closingInteractions.length">
                        <v-list two-line>
                            <v-list-item-group>
                                <v-card
                                    v-for="(interaction, index) in closingInteractions"
                                    :key="interaction.interaction_id"
                                    class="mb-3"
                                    outlined
                                >
                                   <v-card-subtitle class="d-flex align-center pb-2 grey lighten-4">
                                        <div class="font-weight-bold grey--text text--darken-3">
                                            <v-icon small class="mr-1">mdi-message-text-outline</v-icon>
                                            INTERACTION #{{ index + 1 }}
                                        </div>

                                        <v-spacer></v-spacer>

                                        <v-chip
                                            small
                                            label
                                            outlined
                                            color="primary"
                                            class="font-weight-bold"
                                        >
                                            {{ interaction.type || 'N/A' }}
                                        </v-chip>
                                        </v-card-subtitle>

                                    <v-list-item>
                                        <v-list-item-content>
                                            <div 
                                                v-for="(message, mIdx) in interaction.msg" 
                                                :key="mIdx" 
                                                class="d-flex align-center mb-3"
                                                >
                                                <v-text-field
                                                    :label="`Message ${mIdx + 1}`"
                                                    :value="message.text || ''"
                                                    outlined
                                                    readonly
                                                    hide-details
                                                    dense
                                                    class="mr-2"
                                                ></v-text-field>
                                                
                                                <v-btn 
                                                    small 
                                                    icon 
                                                    color="primary" 
                                                    @click.stop.prevent="openEditModal('closing', interaction, mIdx)"
                                                >
                                                    <v-icon small>mdi-pencil</v-icon>
                                                </v-btn>
                                                <v-btn small icon color="red" @click.stop.prevent="opendelete(interaction, 'closing')">
                                                <v-icon small>mdi-delete</v-icon>
                                            </v-btn>
                                            </div>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-card>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-alert type="warning" outlined dense>No closing interactions found.</v-alert>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog class="pa-2" v-model="deletecard" max-width="400">
           <v-card>
        <v-card-title class="headline pa-4 d-flex align-center">
            <v-icon color="red" class="mr-3" size="28">mdi-alert-circle-outline</v-icon>
            Delete Interaction
        </v-card-title>
        
        <v-divider></v-divider>

        <v-card-text class="pa-4">
            <p style="margin-bottom: 0px !important;">
                Are you sure you want to delete this interaction?
            </p>
            <p class="mb-1">
                **This action cannot be undone.**
            </p>
            
            <p class="font-weight-medium">
                To confirm deletion, please type **'DELETE'** in the field below.
            </p>

            <v-text-field
                label="Type 'DELETE' to confirm"
                v-model="deleteconfirm"
                outlined
                dense
                hide-details
                class="mt-1"
                :rules="[v => v === 'DELETE' || v === 'delete' || 'Confirmation text does not match']"
            ></v-text-field>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            
            <v-btn
                text
                variant="text"
                @click="deletecard = false"
            >
                Cancel
            </v-btn>
            
            <v-btn
                color="red"
                style="color: white;"
                :disabled="!allowdelete"
                @click="deletecard = false; deleteinteraction(interactiondata)"
            >
                Delete
            </v-btn>
        </v-card-actions>
    </v-card>
            </v-dialog>

        <v-dialog v-model="showModal" max-width="1000px" max-height="90vh">
            <v-card>
                <v-card-title class="headline sticky-header">
                    {{ isInteractionEdit ? 'Edit Interaction' : `Edit ${currentType === 'welcome' ? 'Welcome' : 'Closing'} Intent` }}
                    <v-spacer></v-spacer>
                                            <v-select
                                                :items="languageOptions"
                                                item-text="text"
                                                item-value="value"
                                                v-model="editLang"
                                                label="Language"
                                                dense
                                                outlined
                                                hide-details
                                                style="max-width: 220px;"
                                            ></v-select>
                </v-card-title>

                    <v-card-text>
                        <v-container>
                            <!-- Top row: language select on left, quick language buttons and placeholder menu on right -->
                            <v-row class="align-center">
                                <v-col cols="12" class="d-flex justify-end align-center">
                                            <!-- Insert placeholder menu (aligned top-right) -->
                                            <v-menu
                                                v-model="menu3"
                                                :close-on-content-click="false"
                                                :nudge-width="300"
                                                offset-y
                                                left
                                                style="max-width:600px;z-index: 99999;"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn small text v-bind="attrs" v-on="on">Insert placeholder</v-btn>
                                                </template>
                                                <v-card>
                                                    <v-list>
                                                        <label class="ml-4">Subject placeholder</label>
                                                        <v-tabs
                                                            vertical
                                                            class="text-left mt-2"
                                                            style="border-top: 1px solid rgba(0, 0, 0, 0.12);"
                                                        >
                                                            <v-tab
                                                                v-for="(plc, p) in placeholders"
                                                                :key="p"
                                                                class="text-left"
                                                                style="display: inline-table; border-right: 1px solid #10b981; font-size: 12px; padding-top: 16px;"
                                                            >
                                                                {{ p }}
                                                            </v-tab>
                                                            <v-tab-item
                                                                class="pa-2 pt-3"
                                                                v-for="(plc, p) in placeholders"
                                                                :key="p"
                                                            >
                                                                <p
                                                                    style="margin: 0 20px 10px 0; display: inline-flex; line-height: 18px; border-radius: 6px; padding: 5px 10px; cursor: pointer; background: rgb(237, 237, 237); font-size: 13px;"
                                                                    v-for="(plc1, p1) in plc"
                                                                    :key="p1"
                                                                    @click="addName(plc1)"
                                                                >
                                                                    {{ plc1 }}
                                                                </p>
                                                            </v-tab-item>
                                                        </v-tabs>
                                                    </v-list>
                                                </v-card>
                                            </v-menu>
                                </v-col>
                            </v-row>

                            <!-- Full width textarea below -->
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea
                                        ref="editTextarea"
                                        :label="languageLabel"
                                        v-model="editFormValue"
                                        outlined
                                        rows="4"
                                        auto-grow
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="closeModal">Cancel</v-btn>
                    <v-btn color="primary" @click="saveChanges">Update</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';
// Assuming VUE_APP_API_URL and route params ($route.query.cid) are available in the Vue instance context.
// Assuming $store.state.SessionModel is available for user names.

export default {
    name: 'WelcomeIntend',
    data() {
        return {
            welcome_questions: null,
            closing_questions: null,
            // Mock initial intent text as they are not fetched from the API response
            welcomeIntent: { en: 'Welcome to our service!', ms: '', tl: '', th: '' },
            closingIntent: { en: 'Thank you for visiting!', ms: '', tl: '', th: '' },
            showModal: false,
            allowdelete:false,
            deleteconfirm:'',
            interactiondata: '',
            currentType: null, // 'welcome' or 'closing'
            isInteractionEdit: false,
            selectedInteraction: null,
            deletecard:false,
            editingIndex: 0,
            editLang: 'en',
            languageOptions: [
                { value: 'en', text: 'English' },
                { value: 'ms', text: 'Malay (MS)' },
                { value: 'tl', text: 'Filipino (TL)' },
                { value: 'th', text: 'Thai (TH)' },
            ],
            menu3: false,
            placeholders: {
                'User': ['{{SessionModel.user.first_name}}', '{{SessionModel.user.last_name}}', '{{SessionModel.user.email}}'],
                'Stage': ['{{SessionModel.stage.chatFromUser.first_name}}'],
                'Company': ['{{SessionModel.company.company_name}}']
            },
            editForm: { en: '', ms: '', tl: '', th: '' },
            welcomeInteractions: [],
            closingInteractions: [],
            userName: '',
        };
    },

    watch: {
        deleteconfirm(val) {
            this.allowdelete = (val.toLowerCase() === 'delete');
        }
    },
    mounted() {
        // Accessing Vuex state for userName. Use null checks for robustness.
        this.userName = (this.$store && this.$store.state && this.$store.state.SessionModel && this.$store.state.SessionModel.user && this.$store.state.SessionModel.user.first_name) || '';
        this.fetchIntentData('welcomeIntentNew');
        this.fetchIntentData('ClosingIntentNew');
    },
    computed: {
        stageChatFromUserName() {
            // Accessing Vuex state for stageChatFromUserName. Use null checks.
            return (this.$store && this.$store.state && this.$store.state.SessionModel && this.$store.state.SessionModel.stage && this.$store.state.SessionModel.stage.chatFromUser && this.$store.state.SessionModel.stage.chatFromUser.first_name) || '';
        },
        editFormValue: {
            get() {
                return this.editForm[this.editLang] || '';
            },
            set(val) {
                this.$set(this.editForm, this.editLang, val);
            }
        },
        languageLabel() {
            const opt = this.languageOptions.find(o => o.value === this.editLang);
            return opt ? opt.text : 'Message';
        }
    },
    methods: {
        deleteinteraction(interaction) {
            this.deleteconfirm='';
            this.allowdelete=false;
            if (!process.env.VUE_APP_API_URL || !this.$route.query.cid || !interaction || !interaction.interaction_id) {
                console.error("API URL, Company ID, or Interaction ID is missing.");
                return;
            }
            const url = `${process.env.VUE_APP_API_URL}company/interactions/${this.$route.query.cid}?interaction_id=${interaction.interaction_id}`;
            axios.delete(url, { withCredentials: true })
                .then(() => {
                    this.$root.$emit('showSnackbar', {
                        message: 'Deleted successfully',
                        color: 'success'
                    });
                    const trigger = this.currentType === 'welcome' ? 'welcomeIntentNew' : 'ClosingIntentNew';
                    this.fetchIntentData(trigger);
                })
                .catch((error) => {
                    console.error('Error deleting interaction:', error);
                });
        },
        opendelete(interaction,type) {
            this.currentType = type;
            this.deletecard=true;
            this.interactiondata = interaction;
        },
        hasTranslations(interaction) {
            return (
                (interaction.questions_ms && interaction.questions_ms.length) ||
                (interaction.questions_tl && interaction.questions_tl.length) ||
                (interaction.questions_th && interaction.questions_th.length)
            );
        },
        fetchIntentData(intentTrigger) {
            const queryParams = {
                count: true,
                intentTrigger: intentTrigger,
            };
            const targetProp = intentTrigger === 'welcomeIntentNew' ? 'welcomeInteractions' : 'closingInteractions';
            const questionsProp = intentTrigger === 'welcomeIntentNew' ? 'welcome_questions' : 'closing_questions';

            // Ensure VUE_APP_API_URL and $route.query.cid are defined before making the API call
            if (!process.env.VUE_APP_API_URL || !this.$route.query.cid) {
                console.error("API URL or Company ID is missing.");
                return;
            }
            
            axios.get(`${process.env.VUE_APP_API_URL}company/interactions/${this.$route.query.cid}`, {
                params: queryParams,
                withCredentials: true
            }).then((response) => {
                console.log(`${intentTrigger} interactions response:`, response.data);
                this[questionsProp] = response.data;
                this[targetProp] = response.data.interactions_details || [];
            }).catch((error) => {
                console.error(`Error fetching ${intentTrigger} interactions:`, error);
                this[targetProp] = []; // Clear data on error
            });
        },
        openEditModal(type, interaction = null, index = 0) {
    this.currentType = type;
    this.isInteractionEdit = !!interaction;
    this.selectedInteraction = interaction;
    this.editingIndex = index; // Store this in data()
    this.editLang = 'en';

    if (this.isInteractionEdit && interaction) {
        // Correctly target the specific message index for all languages
        this.editForm = {
            en: (interaction.msg && interaction.msg[index]) ? interaction.msg[index].text : '',
            ms: (interaction.questions_ms && interaction.questions_ms[index]) ? interaction.questions_ms[index].text : '',
            tl: (interaction.questions_tl && interaction.questions_tl[index]) ? interaction.questions_tl[index].text : '',
            th: (interaction.questions_th && interaction.questions_th[index]) ? interaction.questions_th[index].text : '',
        };
    } else {
        const source = type === 'welcome' ? this.welcomeIntent : this.closingIntent;
        this.editForm = { en: source.en || '', ms: source.ms || '', tl: source.tl || '', th: source.th || '' };
    }
    this.showModal = true;
},
     closeModal() {
            this.showModal = false;
            this.currentType = null;
            this.isInteractionEdit = false;
            this.selectedInteraction = null;
            // Optionally, reset editForm to an empty state
            this.editForm = { en: '', ms: '', tl: '', th: '' };
        },
        addName(plc) {
            // Inserts the selected placeholder into the current textarea at cursor
            try {
                const ref = this.$refs.editTextarea;
                let el = null;
                if (ref) {
                    // Vuetify's v-textarea wraps a native textarea; query for it
                    el = (ref.$el && ref.$el.querySelector) ? ref.$el.querySelector('textarea') : (ref.querySelector ? ref.querySelector('textarea') : null);
                }
                if (!el) {
                    // Fallback: append
                    this.editFormValue = (this.editFormValue || '') + plc;
                    return;
                }
                const start = typeof el.selectionStart === 'number' ? el.selectionStart : (el.value ? el.value.length : 0);
                const end = typeof el.selectionEnd === 'number' ? el.selectionEnd : start;
                const val = this.editFormValue || '';
                const newVal = val.slice(0, start) + plc + val.slice(end);
                this.editFormValue = newVal;
                this.$nextTick(() => {
                    el.selectionStart = el.selectionEnd = start + plc.length;
                    el.focus();
                    // close menu after insertion
                    this.menu3 = false;
                });
            } catch (err) {
                console.error('Error inserting placeholder:', err);
                this.editFormValue = (this.editFormValue || '') + plc;
            }
        },
      saveChanges() {
    if (this.isInteractionEdit && this.selectedInteraction) {
        const targetArr = this.currentType === 'welcome' ? this.welcomeInteractions : this.closingInteractions;
        const idx = targetArr.findIndex(i => i.interaction_id === this.selectedInteraction.interaction_id);

        if (idx !== -1) {
            const interaction = targetArr[idx];
            const lang = this.editLang || 'en';
            const newValue = this.editForm[lang];
            
            const langMap = { en: 'msg', ms: 'questions_ms', tl: 'questions_tl', th: 'questions_th' };
            const apiKey = langMap[lang];
            const payloadKey = (lang === 'en') ? 'questions' : apiKey;

            const mIdx = this.editingIndex || 0;
            let payload = {};

            // Get existing array or default to one empty object
            const currentData = interaction[apiKey] || [{}];
            
            const updatedData = currentData.map((item, i) => {
                if (i === mIdx) {
                    // IF NEW VALUE IS EMPTY: 
                    // We set text to null/empty but KEEP quickReplies via ...item
                    if (!newValue || newValue.trim() === '') {
                        const { ...rest } = item;
                        return { ...rest, text: "" }; // Keeps quickReplies, clears text
                    }
                    // IF NEW VALUE EXISTS:
                    // Merge new text with existing object properties
                    return { ...item, text: newValue };
                }
                return item; // Keep message [0] or [2] etc. completely unchanged
            });

            // If the ENTIRE array results in no text anywhere and you want to clear it
            // you could use: if (updatedData.every(m => !m.text)) payload[payloadKey] = [];
            
            payload[payloadKey] = updatedData;
            
            // Update local state for immediate UI feedback
            this.$set(interaction, apiKey, updatedData);
            this.$set(targetArr, idx, { ...interaction });

            // API Call
            if (process.env.VUE_APP_API_URL && this.$route.query.cid && interaction.interaction_id) {
                const url = `${process.env.VUE_APP_API_URL}company/interactions/${this.$route.query.cid}?interaction_id=${interaction.interaction_id}`;
                axios.patch(url, payload, { withCredentials: true })
                    .then(() => {
                        this.fetchIntentData(this.currentType === 'welcome' ? 'welcomeIntentNew' : 'ClosingIntentNew');
                    })
                    .catch(err => console.error('Update failed:', err));
            }
        }
    } else {
        this.$set(this.currentType === 'welcome' ? this.welcomeIntent : this.closingIntent, this.editLang, this.editForm[this.editLang]);
    }
    this.closeModal();
}
}
};
</script>

<style scoped>
/* Custom styles if needed, but Vuetify handles most styling */
.message-body {
    /* Style for the rendered message */
    white-space: pre-wrap; /* Preserve formatting for variables */
}
.sticky-header {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
}
</style>